<template>
  <el-form
    ref="levelRightsFilterRef"
    class="search-form"
    :inline="true"
    :model="form"
    label-width="90px"
    @keyup.native.enter="handleSearch"
  >
    <el-row :class="openMore ? 'search-bar-content-show' : 'search-bar-content-close'">
      <el-col :span="6">
        <el-form-item label="任务名称">
          <el-input
            v-model="form.name"
            placeholder="请输入任务名称"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="任务类型">
          <el-select
            v-model="form.type"
            clearable
            placeholder="请选择任务类型"
            @change="handleSearch"
          >
            <el-option
              v-for="item in TYPE_LIST"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="状态">
          <el-select
            v-model="form.status"
            clearable
            placeholder="请选择"
            @change="handleSearch"
          >
            <el-option
              v-for="item in STATUS_LIST"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="姓名">
          <el-input
            v-model="form.unifyNameLike"
            placeholder="请输入姓名"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="手机号码">
          <el-input
            v-model="form.mobile"
            placeholder="请输入完整手机号码"
            clearable
            oninput="value=value.replace(/[^0-9]/g,'')"
            :maxlength="11"
            @clear="handleSearch"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <div class="search-btns">
          <div class="moreData" @click="openMore = !openMore">
            {{ !openMore ? "展开筛选" : "收起筛选" }}
            <el-icon :class="openMore ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
          </div>
          <div class="form-btns">
            <el-button class="form-btn" @click.native.prevent="handleReset">
              重 置
            </el-button>
            <el-button
              class="form-btn"
              type="primary"
              @click.native.prevent="handleSearch"
            >
              查 询
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import { STATUS_LIST, TYPE_LIST } from '../constant';

export default {
  name: 'ListFilter',
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      STATUS_LIST,
      openMore: false,
      TYPE_LIST,
    };
  },
  methods: {
    handleSearch() {
      this.$emit('search');
    },
    handleReset() {
      this.$emit('reset');
    },
  },
};
</script>

<style lang="scss" scoped>
.search-btns {
  float:right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .moreData {
    font-size: 12px;
    color: #606266;
    margin-right: 28px;
    &:hover {
      cursor: pointer;
    }
    [class*=" el-icon-"],
    [class^="el-icon-"] {
      color: #06b880 !important;
      font-family: "element-icons" !important;
    }
  }
}
.search-form ::v-deep {
  .el-col {
    margin: 5px 0;
    .el-form-item {
      width: 100%;
      margin: 0;
      .el-form-item__label {
        white-space: nowrap;
        overflow: hidden;
      }
      .el-form-item__content {
        width: calc(100% - 128px);
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
.search-bar-content-close::v-deep {
  .el-col {
    display: none !important;
  }
  .el-col:nth-child(1) {
    display: block !important;
  }
  .el-col:nth-child(2) {
    display: block !important;
  }
  .el-col:nth-child(3) {
    display: block !important;
  }
  .el-col:nth-last-child(1) {
    float: right !important;
    display: block !important;
  }
}
.search-bar-content-show::v-deep {
  .el-col:nth-last-child(1) {
    float: right !important;
  }
}
</style>
